export const DESKTOP_BREAKPOINT = 'xl' as const;
